// Core
import React, { Component } from 'react';

// Components
import {
  GeckoRow,
  GeckoCol,
  GeckoCardWrapper,
  GeckoCardBody,
  GeckoIcon,
  GeckoBtn,
  GeckoCardHeader,
} from 'ui';
import { TooltipIdStr, Tooltip, OverlayTrigger } from 'ui';

// Style
import './style.scss';

const DEFAULT_WIDGET_DATA = {
  title: '',
  description: null,
  render: () => null,
};

export class BaseStat extends Component {
  isHidden(widget) {
    return widget.hideWhen ? widget.hideWhen() : false;
  }

  /**
   * Render all the widgets
   * @return ?element
   */
  renderCards() {
    return this.widgets.map((widget, key) => {
      let widgetData = Object.assign({}, DEFAULT_WIDGET_DATA, widget);
      if (this.isHidden(widget)) {
        return <React.Fragment />;
      }
      return this.renderCard(widgetData, key);
    });
  }

  renderHeaderElem(widget) {
    if (widget.headerButton) {
      return (
        <div className="float-right">
          <GeckoBtn {...widget.headerButton} />
        </div>
      );
    }
    if (widget.customHeaderElement) {
      return <div className="float-right">{widget.customHeaderElement}</div>;
    }
  }

  renderCardHeader(widget, key) {
    return (
      <GeckoCardHeader>
        <div className="d-flex align-items-center font-weight-bold">
          <div className="widget-title mr-2">{widget.title}</div>
          {this.renderWidgetDescription(widget, key)}
        </div>
        {this.renderHeaderElem(widget)}
      </GeckoCardHeader>
    );
  }

  /**
   * Render a single widget
   *
   * @return element
   */
  renderCard(widget, key) {
    return (
      <GeckoCol key={key} width="col-6 col-sm-12 col-md-6">
        <GeckoCardWrapper>
          {this.renderCardHeader(widget, key)}
          <GeckoCardBody padded>{widget.render()}</GeckoCardBody>
        </GeckoCardWrapper>
      </GeckoCol>
    );
  }

  /**
   * Render widget description if one exists
   *
   * @return ?element
   */
  renderWidgetDescription(data, key) {
    if (!data.description) {
      return null;
    }

    let tipId = key + 'descriptionTooltip';

    return (
      <div>
        <OverlayTrigger
          placement="right"
          id={TooltipIdStr(tipId)}
          overlay={<Tooltip id={`tooltip-right`}>{data.description}</Tooltip>}
        >
          <GeckoIcon
            icon="fas fa-question-circle widget-tooltip"
            id={TooltipIdStr(tipId)}
          />
        </OverlayTrigger>
      </div>
    );
  }

  render() {
    return null;
  }
}
